import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import { useState, useEffect } from 'react';
import EfVideo from '@elem/ui/ef-video';
import gtm from '@/utils/gtm';

interface itemType {
    video: string;
    poster: string;
    img?: [string, string];
    title: string | JSX.Element;
    text: string;
    tab: string;
}
export default function D() {
    const { t } = useLang('bkw');
    const [active, setActive] = useState<number>(0);
    const items: itemType[] = [
        {
            video: 'https://websiteoss.ecoflow.com/upload/video/1739181391413/4_1.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1739181691132/4_1.jpg',
            title: t.rich('D_tab1_title', {
                y: (tx: string) => <span className="y">{tx}</span>,
            }),
            text: t('D_tab1_text'),
            tab: t('D_tab1'),
        },
        {
            video: 'https://websiteoss.ecoflow.com/upload/video/1739181391575/4_2.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1739181691320/4_2.jpg',
            title: t.rich('D_tab2_title', {
                y: (tx: string) => <span className="y">{tx}</span>,
            }),
            text: t('D_tab2_text'),
            tab: t('D_tab2'),
        },
    ];

    const handleClickTab = (k: number) => {
        setActive(k);
        const video: HTMLVideoElement | null = document.querySelector(`.bkw-D .video-box .ef-video-item-pc`);
        if (video) {
            video.pause();
            video.currentTime = 0;
            video.src = items[k].video;
            video.play();
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('D_title'),
            button_name: items[k].tab,
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const video: HTMLVideoElement | null = document.querySelector(`.bkw-D .video-box .ef-video-item-pc`);
            if (video) {
                AniContainer.create({
                    triggerElement: '.bkw-D .video-box',
                    triggerHook: 1,
                    offset: video.offsetHeight * 0.5,
                    duration: '100%',
                    onEnter: () => {
                        video.play();
                    },
                });
            }
        }
    }, []);

    return (
        <div id="bkw-D" className={`bkw-D bkw-box inner ${css['bkw-D']}`}>
            <EfSpec />
            <div className="info">
                <h3 className="title title-s">{t('D_title')}</h3>
            </div>
            <div className="content">
                <div className="video-box">
                    <EfVideo pc={items[active].video} poster={items[active].poster} />
                </div>
                <ul className="tabs">
                    {items.map((item: itemType, k: number) => (
                        <li className={`tab${k === active ? ' active' : ''}`} key={k} onClick={() => handleClickTab(k)}>
                            {item.tab}
                        </li>
                    ))}
                </ul>
                <div className="msgs">
                    <p className="msg-text">{items[active].text}</p>
                    <p className="msg-title">{items[active].title}</p>
                </div>
            </div>
        </div>
    );
}
